<template>
  <form @submit.prevent="handleSubmit" class="space-y-4">
    <!-- 分类名称（英文） -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        分类名称（英文） <span class="text-red-500">*</span>
      </label>
      <input
        v-model="formData.name"
        type="text"
        required
        placeholder="例如: english_learning"
        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent dark:bg-gray-700 dark:text-gray-200"
      />
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">用于系统内部标识，建议使用小写字母和下划线</p>
    </div>

    <!-- 显示名称（中文） -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        显示名称（中文） <span class="text-red-500">*</span>
      </label>
      <input
        v-model="formData.display_name"
        type="text"
        required
        placeholder="例如: 英语学习"
        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent dark:bg-gray-700 dark:text-gray-200"
      />
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">用于前端显示的名称</p>
    </div>

    <!-- 描述 -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        描述
      </label>
      <textarea
        v-model="formData.description"
        rows="3"
        placeholder="分类描述（可选）"
        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent dark:bg-gray-700 dark:text-gray-200"
      ></textarea>
    </div>

    <!-- 排序 -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        排序
      </label>
      <input
        v-model.number="formData.order"
        type="number"
        min="0"
        placeholder="数字越小越靠前"
        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent dark:bg-gray-700 dark:text-gray-200"
      />
    </div>

    <!-- 按钮 -->
    <div class="flex justify-end gap-2 pt-4">
      <button
        type="button"
        @click="$emit('cancel')"
        class="cancel-btn"
      >
        取消
      </button>
      <button
        type="submit"
        class="primary-btn"
      >
        {{ isEdit ? '保存' : '创建' }}
      </button>
    </div>
  </form>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import type { CategoryWithSubCategories, CreateCategoryRequest, UpdateCategoryRequest } from '@/types/dictation';

/**
 * Props
 */
const props = defineProps<{
  category?: CategoryWithSubCategories;
}>();

/**
 * Emits
 */
const emit = defineEmits<{
  submit: [data: CreateCategoryRequest | UpdateCategoryRequest];
  cancel: [];
}>();

/**
 * 表单数据
 */
const formData = ref<CreateCategoryRequest | UpdateCategoryRequest>({
  name: '',
  display_name: '',
  description: '',
  order: 0,
});

/**
 * 是否为编辑模式
 */
const isEdit = ref(false);

/**
 * 监听 category 变化，初始化表单数据
 */
watch(
  () => props.category,
  (newCategory) => {
    if (newCategory) {
      isEdit.value = true;
      formData.value = {
        name: newCategory.name,
        display_name: newCategory.displayName,
        description: newCategory.description || '',
        order: newCategory.order || 0,
      };
    } else {
      isEdit.value = false;
      formData.value = {
        name: '',
        display_name: '',
        description: '',
        order: 0,
      };
    }
  },
  { immediate: true }
);

/**
 * 提交表单
 */
const handleSubmit = () => {
  emit('submit', formData.value);
};
</script>

